import { api } from "./api";
import URI from "./URI";

import { clearCookie } from "@/utility/clearCookie";
import { navigateToURL } from "@/utility/navigate"

const redirectPath = "/?next="+import.meta.env.VITE_APP_URL+"&hideref=true"

export const logoutUser = (preventRedirection=false) => {
  return api(
    URI.userLogout,
    { 
        tokenRequired: true,
        method: "DELETE"
     },
    import.meta.env.VITE_PSVC_API_BASE
  ).then((response) => {
   
    clearCookie("llt")
    if(!response?.data?.success){
        console.error("logout failed")
    }
    return response;
  }).finally(()=>{
    if(!preventRedirection){
      navigateToURL(import.meta.env.VITE_SSO_URL+redirectPath)
    }
  })
};
